module.exports = [
  {
    slug: "/",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/Home/DAIF_Home_Loop.mp4'),
    videoBgLoop: require('../assets/Home/DAIF_Home_Loop.mp4'),
    bgImage2: require('../assets/Home/DAIF_Menu.jpg'),
    ctas: [
      {
        url: "/home/video",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/data",
        width: "12%",
        height: "50.6%",
        top: "14.7%",
        left: "20.8%",
        transform: "skewX(-4deg)",
      },
      {
        url: "/data",
        width: "8%",
        height: "24.5%",
        top: "14.7%",
        left: "27.8%",
        transform: "skewX(16deg)",
      },
      {
        url: "/data",
        width: "8%",
        height: "26.3%",
        top: "39%",
        left: "27%",
        transform: "skewX(-19.5deg)",
      },
      {
        url: "/services",
        width: "29%",
        height: "15.6%",
        top: "14.7%",
        left: "35.6%",
        transform: "skewX(17deg)",
      },
      {
        url: "/eco",
        width: "29%",
        height: "8%",
        top: "31.3%",
        left: "38%",
        transform: "skewX(17deg)",
      },
      {
        url: "/eco",
        width: "29%",
        height: "7.8%",
        top: "39.2%",
        left: "38%",
        transform: "skewX(-17deg)",
      },
      {
        url: "/infrastructure",
        width: "30%",
        height: "17%",
        top: "48.6%",
        left: "35%",
        transform: "skewX(-17deg)",
      },
      {
        url: "/usecases",
        width: "12.2%",
        height: "24.7%",
        top: "14.7%",
        left: "66.2%",
        transform: "skewX(21deg)",
      },
      {
        url: "/usecases",
        width: "12.2%",
        height: "26.5%",
        top: "39.2%",
        left: "66.8%",
        transform: "skewX(-15deg)",
      },
      {
        url: "/usecases",
        width: "12.2%",
        height: "26.5%",
        top: "39.2%",
        left: "67%",
        transform: "skewX(-11deg)",
      },
      {
        url: "/security",
        width: "18.5%",
        height: "12.6%",
        top: "68.3%",
        left: "20.8%",
      },
      {
        url: "/sustainability",
        width: "18.5%",
        height: "12.6%",
        top: "68.3%",
        left: "41.7%",
      },
      {
        url: "/why-dell",
        width: "18.5%",
        height: "12.6%",
        top: "68.3%",
        left: "62.5%",
      },
    ],
  },
  {
    slug: "/home/video",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/Home/DAIF_Intro_Play_Video.mp4'),
    videoBgLoop: require('../assets/Home/DAIF_Intro_Play_Video.mp4'),
    bgImage2: require('../assets/Home/DAIF_Menu.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
    ],
  },
]